export default "__VITE_ASSET__CoFZ8UCT__"